import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import CurrencyHelper from '@/Utility/CurrencyHelper';
import CurrencyLabelViewModel from '@/ViewModels/Controls/CurrencyLabelViewModel';
import CurrencyLabel from '@/Controls/CurrencyLabel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class CurrencyLabelFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private CurrencyLabelViewModel = ComponentManager.getViewModel<typeof CurrencyLabelViewModel>('CurrencyLabelViewModel');
    private CurrencyLabel = ComponentManager.getControl<typeof CurrencyLabel>('CurrencyLabel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: CurrencyLabelViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: CurrencyLabel;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.CurrencyLabelViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            value: this.context.genericObject.getComputed(this.detailViewItem.name + '.Value', {
                read: (observable: KnockoutObservable<number>) => {
                    let result = CurrencyHelper.toClientValue(observable());
                    return result;
                },
                write: (observable: KnockoutObservable<number>, value: number) => {
                    let result = CurrencyHelper.toServerValue(value);
                    observable(result);
                }
            }),
            currencyId: this.context.genericObject.getObservable(this.detailViewItem.name + '.CurrencyID')
        });

        this.control = new this.CurrencyLabel(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name + '.Value', this.detailViewItem.name + '.CurrencyID']);

        return this.jQueryControl;
    }

}

ComponentManager.setFactory('CurrencyLabel', CurrencyLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');